import React from 'react';

function Step3({ formData, errors, onChange }) {

  // Función para bloquear físicamente la pulsación de números (0-9) en el teclado
  // Solo permite letras, espacios, tildes y ñ
  const blockNumbers = (e) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    // Permitir teclas de control
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Home" ||
      e.key === "End"
    ) {
      return;
    }

    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // Función para evitar que el usuario copie y pegue texto que contenga números
  const blockNumbersOnPaste = (e) => {
    const texto = e.clipboardData.getData("text");
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;

    if (!regex.test(texto)) {
      e.preventDefault();
    }
  };

  return (
    <div className="step-panel">
      
      <div className="field-group">
        <label htmlFor="telefonofijo">
          Teléfono Fijo 
        </label>
        <input
          id="telefonofijo"
          name="telefonofijo"
          type="text"
          maxLength="10"
          value={formData.telefonofijo || ''} // Seguridad contra undefined
          onChange={onChange}
          onKeyPress={(e) => {
            if (e.key < '0' || e.key > '9') {
              e.preventDefault();
              return;
            }
            if (e.target.value.length >= 10) {
              e.preventDefault();
            }
          }}
          placeholder="Ej: 6041234567 o 3123456"
        />
       
      </div>

      <div className="field-group">
        <label htmlFor="celular">
          Celular <span className="required">*</span>
        </label>
        <input
          id="celular"
          name="celular"
          type="text"
          maxLength="10"
          value={formData.celular || ''} // Seguridad contra undefined
          onChange={onChange}
          onKeyPress={(e) => {
            if (e.key < '0' || e.key > '9') {
              e.preventDefault();
              return;
            }
            if (e.target.value.length >= 10) {
              e.preventDefault();
            }
          }}
          placeholder="Ingrese su número de celular (10 dígitos)"
        />
        {errors.celular && <span className="field-error">{errors.celular}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="celularfamiliar">
          Celular de un Familiar (Contacto de emergencia) <span className="required">*</span>
        </label>
        <input
          id="celularfamiliar"
          name="celularfamiliar"
          type="text"
          maxLength="10"
          value={formData.celularfamiliar || ''}
          onChange={onChange}
          onKeyPress={(e) => {
            if (e.key < '0' || e.key > '9') {
              e.preventDefault();
              return;
            }
            if (e.target.value.length >= 10) {
              e.preventDefault();
            }
          }}
          placeholder="Ingrese número de celular (10 dígitos)"
        />
        {errors.celularfamiliar && <span className="field-error">{errors.celularfamiliar}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="nombrefamiliar">
          Nombre del Familiar <span className="required">*</span>
        </label>
        <input
          id="nombrefamiliar"
          name="nombrefamiliar"
          type="text"
          value={formData.nombrefamiliar || ''} // Seguridad contra undefined
          onChange={onChange}
          onKeyPress={blockNumbers}
          onPaste={blockNumbersOnPaste}  
          placeholder="Ingrese el nombre del familiar"
        />
        {errors.nombrefamiliar && <span className="field-error">{errors.nombrefamiliar}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="parentescofamiliar">
          Parentesco del Familiar <span className="required">*</span>
        </label>
        <input
          id="parentescofamiliar"
          name="parentescofamiliar"
          type="text"
          value={formData.parentescofamiliar || ''} // Seguridad contra undefined
          onChange={onChange}
          onKeyPress={blockNumbers}
          onPaste={blockNumbersOnPaste}  
          placeholder="Ingrese el parentesco del familiar"
        />
        {errors.parentescofamiliar && <span className="field-error">{errors.parentescofamiliar}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="email">
          Correo Electrónico Personal (o Familiar) <span className="required">*</span>
        </label>
        <input
          id="email"
          name="email"
          type="email"
          value={formData.email || ''} // Seguridad contra undefined
          onChange={onChange}
          placeholder="ejemplo@correo.com"
        />
        {errors.email && <span className="field-error">{errors.email}</span>}
      </div>
    </div>
  );
}

export default Step3;